/**
 * Guarda as telas do app no aparelho (service worker /sw.js, gerado no build por src/sw/servico.ts).
 * Só no app publicado: no npm run dev não registra, e o navegador só permite em HTTPS ou localhost
 * (o WMS aberto pelo IP do computador na rede fica sem o cache).
 */
export function registrarCacheDoApp(): void {
  if (!import.meta.env.PROD || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}

/** Saiu versão nova: baixa em segundo plano, para o Atualizar já abrir a versão nova do aparelho. */
export function baixarVersaoNova(): void {
  if (!("serviceWorker" in navigator)) return;
  navigator.serviceWorker.getRegistration().then((r) => r?.update()).catch(() => undefined);
}
